import { useRouterState } from '@tanstack/react-router'

/**
 * Returns the top-level feature tab slug — the 3rd pathname segment
 * (`/{tenant}/{section}/{tab}`). Undefined on paths too short to have one.
 */
export const useCurrentTabLink = () => {
	const routerState = useRouterState()
	const pathname = routerState.location.pathname

	return pathname.split('/')[2]
}
